// most of these don't mean anything nowadays.
// browsers stopped supporting them a while ago
// really, the height and width are the meaningful ones.
const popupWindowFeatures = [
  `menubar=yes`,
  `resizable=yes`,
  `scrollbars=yes`,
  `status=yes`,
  `height=${window.screen.height - 200}`,
  `width=600`
].join(',');

const caseDocsWindowFeatures = [
  `menubar=yes`,
  `resizable=yes`,
  `scrollbars=yes`,
  `status=yes`,
  `height=${window.screen.height - 200}`,
  `width=1024`
].join(',');

export const caseDetailPopup = {
  url: `/json-view/`,
  windowFeatures: popupWindowFeatures,
  windowTitle: 'json-viewer'
};

export const bpmStepsPopup = {
  url: `/bpm-steps/`,
  windowFeatures: popupWindowFeatures,
  windowTitle: 'bpm-steps'
};

export const caseDocumentsPopup = {
  url: `/case-documents/`,
  windowFeatures: caseDocsWindowFeatures,
  windowTitle: 'case-documents'
};

export const launchAmplifyPopup = {
  url: `/accelerate/`,
  windowFeatures: '',
  windowTitle: 'amplify'
};

export const launchAmplifyCase = {
  url: `/cmx/worklist/`,
  windowFeatures: '',
  windowTitle: 'amplify'
};
